import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar expand="lg" className={`navbar-custom ${scrolled ? 'scrolled' : ''}`}>
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ display: 'flex', alignItems: 'center', marginTop: '8px', textDecoration: 'none' }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/${theme === 'dark' ? 'wtrnsprnt200.png' : 'btrnsprnt200.png'}`}
            alt="ZDIVE Logo"
            style={{
              width: '36px',
              height: '36px',
              marginRight: '10px',
              borderRadius: '8px',
              display: 'block',
              marginTop: '-8px'
            }}
          />
          <span style={{
            fontFamily: 'ZDiveFont, sans-serif',
            fontSize: '36px',
            lineHeight: '1',
            display: 'inline-block',
            verticalAlign: 'middle',
            transform: 'translateY(-1px)'
          }}>
            <span style={{ color: '#00B9E9' }}>Z</span>
            <span style={{ color: theme === 'dark' ? 'white' : 'black' }}>DIVE</span>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link href="#features">Features</Nav.Link>
            <Nav.Link href="#watch">Watch App</Nav.Link>
            <Nav.Link href="#ios">iOS App</Nav.Link>
            <Nav.Link href="#planning">Planning</Nav.Link>
            <Nav.Link href="#safety">Safety</Nav.Link>
            <Nav.Link href="#download">Download</Nav.Link>
            <button 
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label="Toggle theme"
            >
              {theme === 'light' ? (
                <i className="fas fa-moon"></i>
              ) : (
                <i className="fas fa-sun"></i>
              )}
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;